import * as React from "react";
import { UitkBadge } from "uitk-react-badge";
import { AllInclusiveContent } from "src/typings/microserviceModels/hotels-flex-module";

export function HotelAllInclusiveBadge(props: AllInclusiveContent) {
  const { title, contentText } = props;

  return <UitkBadge text={title} icon={contentText} className="all-t-margin-three all-l-margin-three hotelBadge" />;
}
